<template>
  <BSkeletonWrapper
    :loading="busy"
  >
    <template #loading>
      <BCard
        body-class="p-2"
      >
        <BCardText
          class="d-flex align-items-center gap-3"
          style="min-height: 60px;"
        >
          <i
            :class="['mb-0', `text-${variant}`, 'fad', icon]"
            style="font-size: 25px;"
          />
          <div class="flex-grow-1">
            <h5
              :class="['mb-0', `text-${variant}`]"
            >
              <BSkeleton
                width="50px"
                height="24px"
              />
            </h5>
            <BSkeleton width="125px" />
          </div>
        </BCardText>
      </BCard>
    </template>
    <BCard
      body-class="p-2"
    >
      <BCardText
        class="d-flex align-items-center gap-3"
        style="min-height: 60px;"
      >
        <i
          :class="['mb-0', `text-${variant}`, 'fad', icon]"
          style="font-size: 25px;"
        />
        <div class="flex-grow-1">
          <h5
            :class="['mb-0', `text-${variant}`]"
          >
            {{ statistics }}
          </h5>
          {{ title }}
        </div>
      </BCardText>
    </BCard>
  </BSkeletonWrapper>
</template>
<script>
export default {
  name: 'FSODashboardCustomer',

  props: {
    busy: {
      type: Boolean,
      required: false,
      default: () => false
    },
    icon: {
      type: String,
      required: true,
      default: () => 'fa-user-plus'
    },
    variant: {
      type: String,
      required: false,
      default: () => 'primary'
    },
    title: {
      type: String,
      required: true,
      default: () => 'New Customers'
    },
    statistics: {
      type: [Number, String],
      required: true,
      default: () => 0
    }
  }
}
</script>
